module.exports = __webpack_public_path__ + "fonts/Holli_9460aa00260126a9c037796127546307.woff2";